module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/cadastro-layout-arquivo/cadastro-layout-arquivo.component.css
// module id = ./src/app/artefato/cadastro-layout-arquivo/cadastro-layout-arquivo.component.css
// module chunks = main